module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-清除文本.3d109.png";